import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { JiraLogo } from "@atlaskit/logo";

import {
    JiraOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useUserContext } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";
import { experiments, ExperimentView } from "@/utils/experiment";

import { WelcomeBackHeading } from "../../components";

export const LoggedInJiraFreeManagedUser = () => (
    <ExperimentView
        experiment={experiments.jfindSignUpFlowOverlay}
        render={(value) =>
            value ? (
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<JiraLogo size="xlarge" appearance="brand" />}
                >
                    <Content />
                </SignupBackgroundLayout>
            )
        }
    />
);

const Content = () => {
    const {
        user: { name }
    } = useUserContext();

    return (
        <>
            <div css={containerCss}>
                <h1 css={headerCss}>
                    <WelcomeBackHeading name={name} />
                </h1>
                <p css={subHeaderCss}>
                    <FormattedMessage
                        id="JiraSoftwarePageTemplate.loggedInHero.pickUpWhereYouLeftOff"
                        defaultMessage="Pick up where you left off in Jira."
                    />
                </p>
                <SiteActivation />
            </div>
        </>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    marginBlockStart: 4,
    marginBlockEnd: 16,
    textAlign: "center"
});
